<template>
  <div>
    <div class="bg-color-red userform_top"></div>
    <div class="userform">
      <h3 class="userform_title">注册商品</h3>
      <div class="userform_item" @click="goSearch">
        <span>
          <span style="color: red">*</span>商品选择：
          <span :style="chooseGoods.store_name != '请选择商品' ? 'color:#4193f8':''">
            {{ chooseGoods.store_name }}
          </span>
        </span>
        
        
      </div>

      <div class="userform_item" style="padding: 0;">
        <div class="date-selection" style="width: 100%;display: flex;align-items: center;padding: 0;">
          <span style="color: red;">
            *
          </span>
          购买时间：
          <div class="date-selection-item" style="flex: 1;" @click="startShowPopup">{{ screen.startTime ?
            screen.startTime : "选择购买日期" }}
          </div>


        </div>


      </div>
      <div class="userform_item" style="padding: 0;">
        <div class="date-selection" style="width: 100%;display: flex;align-items: center;padding: 0;">
          <span style="color: red;">
            *
          </span>
          收货时间：
          <div class="date-selection-item" style="flex: 1;" @click="endShowPopup">{{ screen.endTime ? screen.endTime :
            "选择收货日期" }}</div>


        </div>


      </div>

      <div class="userform_item userform_item_red">
        <input type="text" placeholder="商品SN" v-model.trim="formList.product_sn" />
   
      </div>
      <div class="userform_item userform_item_red">
        <input type="text" placeholder="订单ID" v-model.trim="formList.order_id" />
     
      </div>
      <van-popup v-model="startShow" position="bottom">
        <van-datetime-picker v-model="startTime.currentDate" type="date" title="选择购买日期" :min-date="startTime.minDate"
          :max-date="startTime.maxDate" @confirm="getStartTime" @cancel="cancelStartTime" />
      </van-popup>
      <van-popup v-model="endShow" position="bottom">
        <van-datetime-picker v-model="endTime.currentDate" type="date" title="选择收货日期" :min-date="endTime.minDate"
          :max-date="endTime.maxDate" @confirm="getEndTime" @cancel="cancelEndTime" />
      </van-popup>
      <!-- <div class="userform_item">
        <div class="item acea-row row-between-wrapper">
          <div class="name">置换规格：</div>
          <div class="picker acea-row row-between-wrapper select-value form-control">
            <div class="address">
              <div slot="right" @click.stop="startShow = true">
                {{ joinStandard.describe || "请选择置换规格" }}
              </div>
              <van-popup v-model="startShow" position="bottom">
                <div class="criterion-wrap">
                  <div class="opation">
                    <div class="cancel" @click="startShow = false">取消</div>
                    <div class="desc">选择置换规格</div>
                    <div class="confirm" @click="onConfirm">确认</div>
                  </div>
                  <ul class="criterion-list">
                    <li class="criterion-item" :class="[item.checked ? 'on' : '']" v-for="item in columns" :key="item.id"
                      @click="selectColumnsItem(item)">
                      <div class="criterion-item-wrap">
                        <div class="text-remarks-wrap">
                          <div class="text">{{ item.describe }}</div>
                          <div class="remarks">{{ item.remarks }}</div>
                        </div>
                        <div class="pay">
                          <img src="@images/renminbi.png">
                          <span>{{ item.pay }}</span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </van-popup>
            </div>
          </div>
        </div>
      </div> -->
      <!-- <div class="userform_item userform_item_red" style="display: flex; justify-content: space-between;">
        <div>请填写置换数量</div>
        <input type="number" onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" placeholder=""
          max="999" v-model.trim="formList.verifi" class="yzm_number" @input="submit" />
        <p class="userform_item_label" v-if="formlabel.warnstatus == 2">请填写置换数量</p>
      </div> -->
      <!-- <div class="userform_item userform_item_red">
        <div>{{ formList.displacePay }} 元 × {{ formList.verifi }}件</div>
        <div class="red">合计： {{ formList.total }} 元</div>
      </div> -->
      <button class="userform_submit"  style="margin-bottom: 10px;background: #dcdcdc;" @click="clearInfo()">
        清空信息
      </button>
      <button class="userform_submit bg-color-red" @click="userformsubmit()">
        立即注册
      </button>
    </div>

    <div class="bnt bg-color-red " style="margin: 70px  30px 0 ;border-radius: 5px; color: #fff;height: 40px;display: flex;justify-content: center;align-items: center;" @click="goRecord()">
              商品注册记录
    </div>

  </div>
</template>
<script>
      // 获取当前日期对象
        const currentDate = new Date();

        // 获取年份（4位完整年份）
        const year = currentDate.getFullYear();
        // 获取月份：getMonth() 返回 0-11（0代表1月），所以需要+1
        const month = currentDate.getMonth() + 1;
        // 获取日期（1-31，无需额外处理）
        const day = currentDate.getDate();

        // 拼接成指定格式：年, 月, 日
        const formattedDate = year + ', ' + month + ', ' + day;

       



import {
  displaceApply, getUserInfo ,
  postProductReg
} from "@api/user";
import { VUE_APP_API_URL } from "@utils";
import VueCoreImageUpload from "vue-core-image-upload";
import { getDisplaceType } from "@api/public";
import { displaceCreate } from "@api/order"
import { pay } from "@libs/wechat";
import { isWeixin } from "@utils";
const _isWeixin = isWeixin();
import Picker from 'vant/lib/picker';
import 'vant/lib/picker/style';
import Popup from 'vant/lib/popup';
import 'vant/lib/popup/style';
import Checkbox from 'vant/lib/checkbox';
import 'vant/lib/checkbox/style';
import CheckboxGroup from 'vant/lib/checkbox-group';
import 'vant/lib/checkbox-group/style';

import DatetimePicker from 'vant/lib/datetime-picker';
import 'vant/lib/datetime-picker/style';
export default {
  name: "registerGoods",
  components: {
    VueCoreImageUpload,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [DatetimePicker.name]: DatetimePicker,
  },
  data: function () {
    return {
      userInfo: {},
      from: _isWeixin ? "weixin" : "weixinh5",
      active: _isWeixin ? "weixin" : "yue",
      // 加盟方式
      startShow: false,
      columns: [],
      joinStandard: "",
      // 图片上传
      url: `${VUE_APP_API_URL}/upload/image`,
      headers: {
        "Authori-zation": "Bearer " + this.$store.state.app.token
      },

      otherImages: [],
      //
      formList: {
       product_sn:'',
       order_id:'',
      },
      formlabel: {
        warnstatus: 0,
        text: '姓名'
      },
      keyCode: '',
      type: '',
      codeVal: '',

      agentlevelshow: false,
      checklevel: true,
      refund_reason_wap_img: [],
      // 城市选择弹窗
      show2: false,
      show3: false,
      model2: "",
      district: [],
      address: {},
      ready: false,
      ready3: false,
      apply_id: "",
      apply_pay: "",
      agent_range: "",
      is_agree: false,
      chooseGoods:{
        store_name:'请选择商品'
      },
      checked: false,
      agreementContent: {},

      heightlight: '',

      address_detail: '',
      agreementShow: false,
      screen: {

        startTime: "",
        endTime: ""
      },
      // 时间
      startTime: {
        minDate: new Date(2020, 0, 1),
        maxDate: new Date(2026,11,1),
        currentDate: new Date(),
      },
      endTime: {
        minDate: new Date(2020, 0, 1),
        maxDate: new Date(2026, 11, 1),
        currentDate: new Date(),
      },
      startShow: false,
      endShow: false,
      
      selectStartTime: 0,
      selectEndTime: 0,
    }
  },

   activated() {
      let chooseGoods =JSON.parse( localStorage.getItem('chooseGoods') )

    if(chooseGoods) {
      this.chooseGoods = chooseGoods
    }
  },
  mounted: function () {


     console.log(new Date(this.dateConfig()))
     

  },
  methods: {

    dateConfig(){
        // 获取当前日期对象
        const currentDate = new Date();

        // 获取年份（4位完整年份）
        const year = currentDate.getFullYear();
        // 获取月份：getMonth() 返回 0-11（0代表1月），所以需要+1
        const month = currentDate.getMonth() + 1;
        // 获取日期（1-31，无需额外处理）
        const day = currentDate.getDate();

        // 拼接成指定格式：年, 月, 日
        const formattedDate = year + ', ' + month + ', ' + day;

        return formattedDate;
    },  
    goRecord(){
       this.$router.push({path:`/registerRecord`})
    },
    getEndTime: function (val) {
      let isEndTime = val.getTime();
      let isStartTime = 0;
      this.endShow = false;
      if (this.selectStartTime) {
        isStartTime = this.selectStartTime.getTime();
      }
      if (isStartTime > isEndTime) {
        // this.screen.endTime = '请选择结束日期';
        return this.$dialog.error('开始时间不能大于结束时间');
      }
      this.selectEndTime = val;
      this.endTime.currentDate = val;
      this.screen.endTime = this.timeFormat(val);
      this.endShow = false;
       localStorage.setItem('endTime',JSON.stringify(val))
      if (this.screen.startTime && this.screen.endTime && this.screen.startTime != '请选择开始日期') {
        this.spreadList = [];
        this.loaded = false;
        this.loading = false;
        this.screen.page = 1;
        this.getSpreadUsers();
      }
    },
    // 获取时间
    getStartTime: function (val) {
      let isStartTime = val.getTime();
      let isEndTime = 1.7976931348623157E+10308;

      this.startShow = false;

      if (this.selectEndTime) {
        isEndTime = this.selectEndTime.getTime()
      }
      if (isStartTime > isEndTime) {
        // this.screen.startTime = '请选择开始日期';
        return this.$dialog.error('收货日期不能大于购日期');
      }

      this.selectStartTime = val;
      this.startTime.currentDate = val;
      this.screen.startTime = this.timeFormat(val); 

      localStorage.setItem('startTime',JSON.stringify(val))
      if (this.screen.startTime && this.screen.endTime && this.screen.endTime != '请选择收货日期') {



      } 
    },
    goSearch(){
        // this.$route.push('/search') 

        this.$router.push({path:`/search?choose=1`})
    },
    // 弹出时间选择器
    startShowPopup() {
      this.startShow = true;
    },
    endShowPopup() {
      this.endShow = true;
    },
    // 关闭时间选择器
    cancelStartTime() {
      this.startShow = false;
    },
    cancelEndTime() {
      this.endShow = false;
    },
    getUserInfo() { //获取用户信息
      // getUserInfo().then(res => {
      //   this.userInfo = res.data;
      // })
    },
    showAgreement() {
      this.agreementShow = true
    },
    showPopup() {
      this.startShow = true;
    },
    closeAgentLevel(index) {
      this.checklevel = false;
      this.formList.agentlevelname = this.agentarray[index].name;
      this.formList.agentlevelamount = this.agentarray[index].amount;
      this.agentlevelshow = false;
    },
    clearInfo(){
      this.chooseGoods = {
         store_name:'请选择商品'
      }

 


      localStorage.removeItem('chooseGoods')
      localStorage.removeItem('startTime')
      localStorage.removeItem('endTime')
       this.screen.startTime =''
       this.screen.endTime =''
         this.formList.product_sn = ''
         this.formList.order_id = ''
    },
    async userformsubmit() {
      if (this.chooseGoods.store_name == '请选择商品') return this.$dialog.message("请选择商品");
     
    
      if (this.screen.buy_date == '') return this.$dialog.message("请填写购物时间");
      if (this.screen.receiving_date == '') return this.$dialog.message("请填写收货时间"); 

      console.log(this.screen.startTime);
      console.log(this.screen.endTime);
      // return
      // 信息均已，向服务器传递申请人信息
      postProductReg({
        product_id: this.chooseGoods.id,
        buy_date: this.screen.startTime,
        receiving_date: this.screen.endTime ,
        product_sn: this.formList.product_sn ,
        order_id: this.formList.order_id
      }).then(res => {
        this.$dialog.success("提交成功");
      
        this.clearInfo()
      }).catch(err => {
        this.$dialog.error(err.msg);
      })

    },
    timeFormat(time) { // 时间格式化 2019-09-08
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();

      // Add zero padding for month and day
    month = month < 10 ? '0' + month : month;
    day = day < 10 ? '0' + day : day;
    
      return year + '-' + month + '-' + day;
    },
    // 创建订单
    displaceCreate(id) {
      let orderid = id
      let data = {
        id: orderid,
        from: this.from,
        payType: this.active,
      };
      displaceCreate(data).then(res => {
        this.$dialog.loading.close();
        const data = res.data;
        if (data.status == 'WECHAT_PAY') {
          pay(data.result.jsConfig).finally(() => {
            this.$router.push({
              path: `/order/status_displace/${data.result.orderId}`
            });
          });
        } else {
          this.$dialog.error("支付失败");
        }
        return
      })
    },
    result2(ret) {
      console.log(ret, '132')
      this.model2 = ret.itemName1 + " " + ret.itemName2 + " ";
      this.address.province = ret.itemName1;
      this.address.city = ret.itemName2;
      this.address.city_id = ret.itemValue2;

    },
    result3(ret) {
      this.delivery_address = ret.itemName1 + ' ' + ret.itemName2 + ' ' + ret.itemName3
    },
    // 获取置换类型
    getConditionLlist() {
      getDisplaceType().then(res => {
        this.columns = res.data;
      }).catch(res => {
        this.$dialog.error(res.msg)
      })
    },
    selectColumnsItem(item) {
      console.log('1-->', item);
      this.heightlight = item.id;
      this.columns.forEach(i => {
        if (i.hasOwnProperty('checked')) {
          i.checked = false;
        } else {
          this.$set(i, 'checked', false);
        }
      })
      item.checked = true;
    },
    // 加盟标准确认
    onConfirm(e) {
      let res = this.columns.filter(item => {
        return item.checked
      })
      console.log(res);
      if (res.length === 0 && res.length !== 1) return this.$dialog.message('请选择一项加盟标准');
      this.joinStandard = res[0];
      this.startShow = false;
      this.formList.displacePay = this.joinStandard.pay
      this.submit()
    },
    /**
      * 手机号校验
    */
    validPhone(phone) {
      if (
        !/^((13[0-9])|(14[5-9])|(15([0-3]|[5-9]))|(16[6-7])|(17[1-8])|(18[0-9])|(19[1|3])|(19[5|6])|(19[8|9]))\d{8}$/.test(phone)
      ) {
        return false
      } else {
        return true
      }
    },
    // 计算价格
    submit(e) {
      if (this.formList.displacePay == 0) {
        this.$dialog.error("请选择规格");
        this.formList.verifi = null
      }
      this.formList.total = this.formList.displacePay * this.formList.verifi
      console.log(this.formList.total);
    }
  },
  watch: {
    startShow(newvalue, oldvalue) {
      this.columns.forEach(item => {
        if (item.id === this.joinStandard.id) {
          if (item.hasOwnProperty('checked')) {
            item.checked = true;
          } else {
            this.$set(item, 'checked', true);
          }
        } else {
          if (item.hasOwnProperty('checked')) {
            item.checked = false;
          } else {
            this.$set(item, 'checked', false);
          }

        }
      })

      // if(this.joinStandard === ''){
      //   this.columns.forEach(i => {
      //     if(i.hasOwnProperty('checked')){
      //       i.checked = false;
      //     }else{
      //       this.$set(i,'checked',false);
      //     }
      //   })
      // }
      // else{
      //   this.columns.forEach(i => {
      //     if(this.joinStandard.id === i.id){
      //       this.$set(i,'checked',true)
      //     }
      //   })
      // }

    },
  }
};
</script>
<style scoped>
.userform_top {
  width: 100%;
  height: 150px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  background: linear-gradient(0deg, #434343, #000000);
  background: -webkit-linear-gradient(0deg, #434343, #000000);
  background: -moz-linear-gradient(0deg, #434343, #000000);
  background: -ms-linear-gradient(0deg, #434343, #000000)
}

.userform {
  font-size: 15px;
  box-sizing: border-box;
  border-radius: 0.8em;
  padding: 1.6em;
  width: 85%;
  margin: 50px auto 0;
  background: #ffffff;
  box-shadow: 2px 2px 16px 0 rgba(0, 0, 0, 0.08);
  color: #000;
  position: relative;
  z-index: 1000
}

.userform .userform_title {
  text-align: center;
  font-size: 20px;
  padding-bottom: 1.2em
}

.userform .userform_item {
  width: 100%;
  margin: 0 auto;
  margin-bottom: 1.6em;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative
}

.userform .userform_item .yzm {
  width: 7.6em;
  padding: 0 0.6em;
  background: #80cdd4;
  color: #ffffff;
  margin-left: 0.6em;
  line-height: 2.4em;
  text-align: center
}

.userform .userform_item_agent {
  border-bottom: 1px solid #80cdd4;
  color: #80cdd4
}

.userform .userform_item_agent .agent_level_info {
  width: 100%;
  display: flex;
  justify-content: space-between;
  line-height: 2.4em;
  padding-left: 1.2em
}

.userform .userform_item_agent .agent_level_child {
  box-sizing: border-box;
  width: 100%;
  position: absolute;
  top: 2.4em;
  z-index: 1000;
  color: #000;
  background: #ffffff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  line-height: 2em;
  padding: 1em;
  border-radius: 0 0 4px 4px;
  border-top: 1px solid #80cdd4
}

.userform .userform_item_agent .agent_level_name span {
  display: inline-block;
  color: #80cdd4;
  font-weight: 600;
  margin-right: 0.3em
}

.userform .userform_item .yzm.actived {
  background: #f2f2f2;
  color: #999999
}

.userform .userform_item .yzm_number {
  width: 8em;
  text-align: center;
  letter-spacing: 1px
}

.userform .userform_item .agentcode {
  width: 10.6em;
  text-align: center;
  color: #000;
  margin-right: 0.4em
}

.userform .userform_item input,
.userform .userform_item textarea {
  width: 100%;
  display: block;
  background: #f5f5f5;
  border-radius: 4px;
  color: #000;
  line-height: 1.6em;
  padding: 0.6em 0.6em
}

.userform .userform_item input {
  line-height: 2.4em;
  padding: 0 1em
}

.userform .userform_item_textarea.userform_item {
  align-items: flex-start
}

.userform .userform_item_bottom {
  display: flex
}

.userform .userform_item .userform_agreement {
  display: flex
}

.userform .userform_item .userform_agreement span {
  color: #80cdd4
}

.userform .userform_item .red {
  color: crimson;
}

.userform_item_label {
  font-size: 12px;
  color: rgb(255, 70, 70);
  position: absolute;
  left: 0;
  bottom: -2em;
  z-index: 1000;
  text-indent: 1em;
  line-height: 2em;
  text-align: left
}

.userform_submit {
  margin: 0 auto;
  display: block;
  width: 80%;
  line-height: 2.4em;
  border-radius: 1.2em;
  background: linear-gradient(90deg, #80cdd4, #80cdd4);
  background: -webkit-linear-gradient(90deg, #80cdd4, #80cdd4);
  background: -moz-linear-gradient(90deg, #80cdd4, #80cdd4);
  background: -ms-linear-gradient(90deg, #80cdd4, #80cdd4);
  text-align: center;
  font-weight: 600;
  color: #452f0d
}

.userform_description {
  width: 90%;
  margin: 0 auto;
  font-size: 14px;
  padding-top: 2em;
  line-height: 1.6em;
  color: #80cdd4
}

.userform_description p {
  font-size: 1.2em;
  display: inline-block;
  font-weight: 600
}

.uploader_form .tips {
  font-size: .3rem;
  color: #848484;
  margin-bottom: .2rem
}

.uploader_form .tips span {
  color: rgb(223, 53, 53)
}

.agreement {
  display: flex;
  margin-bottom: 1.6em
}

.agreement .agreement-details {
  color: #9dccd0
}

.van-popup.van-popup--center {
  border-radius: 10px
}

.agreement-article {
  width: 80vw;
  height: 80vh;
  padding: .5rem .4rem .4rem;
  border-radius: 10px
}

.agreement-article .title {
  font-size: .48rem;
  font-weight: 700;
  margin-bottom: .3rem
}


.criterion-wrap .opation {
  display: flex;
  justify-content: space-between;
  padding: .2rem .3rem;
  border-bottom: 1px solid #f0f0f0;
}

.criterion-wrap .opation .cancel,
.criterion-wrap .opation .confirm {
  font-size: .32rem;
  color: #2c92d7;
}

.criterion-wrap .opation .desc {
  font-size: .32rem;
  color: #000;
  font-weight: 600;
}

.criterion-wrap .criterion-list {
  white-space: nowrap;
  overflow-x: scroll;
  margin: .54rem 0;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.criterion-wrap .criterion-list::-webkit-scrollbar {
  display: none;
}

.criterion-wrap .criterion-list .criterion-item:first-of-type {
  margin-left: .5rem;
}

.criterion-wrap .criterion-list .criterion-item {
  display: inline-block;
  width: 4.5rem;
  height: 4.8rem;
  white-space: normal;
  padding: .32rem .28rem;
  border: 1px solid #e1e1e1;
  border-radius: 10px;
  vertical-align: bottom;
  margin-right: .4rem;
}

.criterion-wrap .criterion-list .criterion-item.on {
  border-color: #cea85f;
  background: rgb(206, 168, 95, .12);
}

.criterion-list .criterion-item .criterion-item-wrap {
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  align-content: space-between;
}

.criterion-list .criterion-item .text {
  font-size: .3rem;
  color: #333;
  font-weight: 700;
  text-align: justify;
}

.criterion-list .criterion-item .remarks {
  font-size: .28rem;
  color: #a7a7a7;
  text-align: justify;
  margin-top: .16rem;
}

.criterion-list .criterion-item .pay {
  width: 100%;
  text-align: right;
  font-size: .48rem;
  color: #cea85f;
  font-weight: 500;
  line-height: 1;
}

.criterion-list .criterion-item .pay img {
  width: .36rem;
  vertical-align: bottom;
}
</style>
